import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef, AfterViewChecked, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { ChatMessage, ChatTab } from '../ai-chat.types';

@Component({
  selector: 'app-ai-chat-window',
  templateUrl: './ai-chat-window.component.html',
  styleUrls: ['./ai-chat-window.component.scss']
})
export class AiChatWindowComponent implements OnInit, AfterViewChecked, OnChanges, AfterViewInit {
  @Input() chatTab!: ChatTab;
  @Input() isLoading: boolean = false;
  @Input() currentMessage: string = '';
  
  @Output() messageChange = new EventEmitter<string>();
  @Output() sendMessage = new EventEmitter<void>();
  @Output() clearChat = new EventEmitter<void>();
  @Output() exportChat = new EventEmitter<void>();
  @Output() quickTutorialRequest = new EventEmitter<string>();

  @ViewChild('messagesContainer') messagesContainer!: ElementRef;
  @ViewChild('messageInput') messageInput!: ElementRef;

  showQuickActions: boolean = false;
  private shouldScrollToBottom = false;
  private _lastMessageCount = 0;

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    // Initial scroll to bottom when the view is ready
    this.forceScrollToBottom();
  }

  ngAfterViewChecked() {
    // If flagged, scroll
    if (this.shouldScrollToBottom)
    {
      this.scrollToBottom();
      this.shouldScrollToBottom = false;
    }

    // Detect new messages and auto-scroll
    const currentCount = this.chatTab ? (this.chatTab.messages?.length || 0) : 0;
    if (currentCount !== this._lastMessageCount)
    {
      // Use setTimeout to ensure DOM updates are complete
      setTimeout(() => this.scrollToBottom(), 0);
      this._lastMessageCount = currentCount;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // If chatTab instance changes, ensure we track message count and scroll
    if (changes.chatTab)
    {
      const count = this.chatTab ? (this.chatTab.messages?.length || 0) : 0;
      this._lastMessageCount = count;
      // Defer to next tick so DOM updates complete
      setTimeout(() => this.forceScrollToBottom());
    }
  }

  onMessageChange(value: string) {
    this.messageChange.emit(value);
  }

  onSendMessage() {
    if (this.currentMessage.trim() && !this.isLoading) {
  this.shouldScrollToBottom = true;
      this.sendMessage.emit();
    }
  }

  onKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.onSendMessage();
    }
  }

  onClearChat() {
    this.clearChat.emit();
  }

  onExportChat() {
    this.exportChat.emit();
  }

  toggleQuickActions() {
    this.showQuickActions = !this.showQuickActions;
  }

  onQuickTutorialRequest(message: string) {
    this.showQuickActions = false;
    this.quickTutorialRequest.emit(message);
  }

  trackByMessage(index: number, message: ChatMessage): string {
    return message.id;
  }

  private scrollToBottom() {
    if (this.messagesContainer) {
      const container = this.messagesContainer.nativeElement;
      // Always scroll to bottom when new messages arrive
      container.scrollTop = container.scrollHeight;
    }
  }

  private forceScrollToBottom() {
    // Force scroll regardless of prior state
    if (this.messagesContainer)
    {
      const container = this.messagesContainer.nativeElement;
      container.scrollTop = container.scrollHeight;
    }
  }
}